import { environment } from '../../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('AccountService', AccountService);

  AccountService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    '$location',
    'UploadService',
  ];

  function AccountService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    $location,
    UploadService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'accounts';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getAccounts: getAccounts,
      getAccount: getAccount,
      saveAccount: saveAccount,
      openLogo: openLogo,
      updateLogo: updateLogo,
      changeAccountStatus: changeAccountStatus,
      updateAccounts: updateAccounts,
      removeAccountPlanAddon: removeAccountPlanAddon,
      createGuestAccount: createGuestAccount,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'account_name',
      };

      return filterCriteria;
    }

    function getAccounts(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getAccount(id) {
      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        {},
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveAccount(params, cropedImage) {
      var itemAddedMsg = $translate('NEW_ADDED_ACCOUNT');
      var itemAddedFlashMsg = $translate('ACCOUNT_ADDED_MSG');
      var itemModifiedMsg = $translate('MODIFIED_ACCOUNT');

      var account = params.account;

      var method = account.id ? 'put' : 'post';
      var url = account.id ? apiUrl + '/' + account.id : apiUrl;

      // check
      return UploadService.uploadFile(
        method,
        url,
        '',
        params,
        cropedImage,
        function () {},
        function (response) {
          var msg = account.id ? itemModifiedMsg : itemAddedMsg;
          utils._successMsg(msg);

          if (!account.id) {
            // Create
            utils._setFlashMessage(itemAddedFlashMsg);
          }

          return response;
        },
        function () {}
      );
    }

    function openLogo(item, saveLogoCallBack) {
      utils.openLogo(item, saveLogoCallBack, 220, 220);
    }

    // Update logo after crop
    function updateLogo(item, cropedImage) {
      var url = apiUrl + '/' + item.id + '?lang=' + config.DEFAULT_CONTENT_LANGUAGE;

      utils.updateLogo(url, 'account', item, cropedImage);
    }

    function changeAccountStatus(item) {
      utils.changeItemStatus(apiUrl + '/' + item.id, item);
    }

    function updateAccounts(action, items, successCallback) {
      utils.updateItems(apiUrl, action, items, successCallback);
    }

    // Remove account plan_addon
    function removeAccountPlanAddon(accountId, accountPlanAddonId) {
      var url = apiUrl + '/' + accountId + '/remove_account_plan_addon/' + accountPlanAddonId;
      return RestResource.request(
        'delete',
        url,
        {},
        function () {},
        function () {}
      );
    }

    function createGuestAccount(params) {
      var url = apiUrl + '/create_guest_account';

      function success(response) {
        var msg = $translate('ACTIVATE_ACCOUNT_MSG');
        utils._setFlashMessage(msg);

        $location.path('/login');

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request('post', url, params, success, failure);
    }
  }
})();
